var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArbBackdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9974_6086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.627 57.2553L54.8505 64.6891C54.7686 64.8952 54.7686 65.1243 54.8505 65.3305L59.6185 78.1251L65.1365 75.0094L58.5174 57.2553C58.365 56.843 57.7793 56.843 57.627 57.2553Z",
    fill: "url(#paint0_linear_9974_6086)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1815 44.7472C63.0292 44.3349 62.4435 44.3349 62.2912 44.7472L59.5147 52.181C59.4326 52.3874 59.4326 52.6164 59.5147 52.8226L67.3286 73.7725L72.8465 70.6568L63.1815 44.7472Z",
    fill: "url(#paint1_linear_9974_6086)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.375 28.4707C53.5155 28.4707 53.6445 28.505 53.7733 28.5737L74.8137 40.4518C75.0598 40.5893 75.212 40.8413 75.212 41.1162V64.8724C75.212 65.1473 75.0598 65.3993 74.8137 65.5366L53.7733 77.4263C53.6562 77.4949 53.5155 77.5294 53.375 77.5294C53.2345 77.5294 53.1055 77.4949 52.9767 77.4263L31.948 65.5482C31.702 65.4107 31.5497 65.1586 31.5497 64.8839V41.1162C31.5497 40.8413 31.702 40.5893 31.948 40.4518L52.9884 28.5737C53.1055 28.505 53.2462 28.4707 53.375 28.4707ZM53.375 25C52.6253 25 51.8754 25.1947 51.2076 25.5727L30.1673 37.4508C28.8318 38.2068 28 39.6042 28 41.1162V64.8724C28 66.3843 28.8318 67.7933 30.1673 68.5493L51.2076 80.4272C51.8754 80.8052 52.6253 81 53.375 81C54.1247 81 54.8746 80.8052 55.5424 80.4272L76.5826 68.5493C77.93 67.7933 78.75 66.3957 78.75 64.8724V41.1162C78.75 39.6042 77.9182 38.1953 76.5826 37.4394L55.5541 25.5727C54.8746 25.1947 54.1247 25 53.375 25Z",
    fill: "url(#paint2_linear_9974_6086)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6039 39.4209H46.2736C45.8753 39.4209 45.512 39.6614 45.3832 40.028L33.9492 70.6796L39.4671 73.7951L52.0609 40.0394C52.1662 39.7416 51.9436 39.4209 51.6039 39.4209Z",
    fill: "url(#paint3_linear_9974_6086)",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9413 39.4209H55.611C55.2127 39.4209 54.8494 39.6614 54.7206 40.028L41.6582 75.0322L47.176 78.1479L61.3865 40.0509C61.5036 39.7416 61.2694 39.4209 60.9413 39.4209Z",
    fill: "url(#paint4_linear_9974_6086)",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9974_6086",
    x1: 59.9628,
    y1: 56.946,
    x2: 59.9628,
    y2: 78.1251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#060606",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9974_6086",
    x1: 66.1498,
    y1: 44.438,
    x2: 66.1498,
    y2: 73.7725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111010",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9974_6086",
    x1: 53.375,
    y1: 25,
    x2: 53.375,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9974_6086",
    x1: 43.0182,
    y1: 39.4209,
    x2: 43.0182,
    y2: 73.7951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343333",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9974_6086",
    x1: 51.5376,
    y1: 39.4209,
    x2: 51.5376,
    y2: 78.1479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3737",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9974_6086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    rx: 53,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArbBackdrop);
export default __webpack_public_path__ + "static/media/arbBackdrop.b297943b6624c2f22d35e13535ee17f0.svg";
export { ForwardRef as ReactComponent };